import { QuestionOptionSalesType as Question } from "@/components/features/items/edit/option/_shared/ui/components/sales-type";

import { useOptionSalesType } from "./hooks";

export const QuestionOptionSalesType = () => {
	const {
		isEdited,
		hasError,

		optionType,
		onSetOptionType,
		optionTypeOptions,

		shouldShowBillingTypeTarget,
		billingTypeTarget,
		onSetBillingTypeTarget,
		billingTypeTargetOptions,

		maxBuyableNumPerTarget,
		onSetMaxBuyableNumPerTarget,
	} = useOptionSalesType();

	return (
		<Question
			isEdited={isEdited}
			hasError={hasError}
			optionType={optionType}
			onSetOptionType={onSetOptionType}
			optionTypeOptions={optionTypeOptions}
			shouldShowBillingTypeTarget={shouldShowBillingTypeTarget}
			billingTypeTarget={billingTypeTarget}
			onSetBillingTypeTarget={onSetBillingTypeTarget}
			billingTypeTargetOptions={billingTypeTargetOptions}
			maxBuyableNumPerTarget={maxBuyableNumPerTarget}
			onSetMaxBuyableNumPerTarget={onSetMaxBuyableNumPerTarget}
		/>
	);
};

QuestionOptionSalesType.displayName = "QuestionOptionSalesType";
